import React from "react";

export const SkipToContent = () => (
  <a
    data-testid="skip-to-content-link"
    href="#content"
    className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:rounded-lg focus:bg-[var(--wf-maroon)] focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-[var(--wf-paper)] focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[var(--wf-maroon)]"
  >
    Skip to content
  </a>
);
